const PLUGIN_ID = 'strapi-google-maps';

export { PLUGIN_ID };